import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import EvaluacionesView from './EvaluacionesView';
import * as ROUTES from '../../../router/Routes';

const EvaluacionesModule = () => {
  return (
    <ContainerTemplate active={ROUTES.evaluaciones} routes={[ROUTES.academico]}>
      <EvaluacionesView />
    </ContainerTemplate>
  );
};

export default EvaluacionesModule;
